import riot from 'riot';
import events from '../src/events.js';
import { getQuestions as fetchQuestions, getAnswers as fetchAnswers, getActivityTelemetry as fetchActivityTelemetry } from '../src/lib.js';
riot.tag2('participant-details', '<div class="columns is-multiline" style="margin-top: 5px;"> <div class="column is-12"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <header class="card-header"> <p class="card-header-title"> <span class="icon is-small" style="margin-right: 0.5rem;"> <i class="fas fa-user"></i> </span> Participant Overview </p> </header> <div class="card-content"> <div class="content"> <div class="columns is-multiline is-vcentered" style="margin-bottom: 0.75rem;"> <div class="column is-12-mobile is-4-tablet is-4-desktop"> <button class="button is-info is-light is-fullwidth" onclick="{parent.exitDashboardClick}"> Back to All Participants </button> </div> <div class="column is-12-mobile is-4-tablet is-4-desktop has-text-centered"> <p class="is-size-7 has-text-grey" style="margin-bottom:0.35rem;">Participant</p> <span class="tag is-light">{parent.getSelectedParticipantPositionLabel()}</span> </div> <div class="column is-12-mobile is-4-tablet is-4-desktop"> <div class="columns is-mobile"> <div class="column"> <button class="button is-info is-light is-fullwidth" onclick="{parent.previousParticipantClick}" disabled="{!parent.hasPreviousParticipant()}"> Previous </button> </div> <div class="column"> <button class="button is-info is-light is-fullwidth" onclick="{parent.nextParticipantClick}" disabled="{!parent.hasNextParticipant()}"> Next </button> </div> </div> </div> </div> <div class="columns is-multiline"> <div class="column is-4-desktop is-12-mobile"> <div class="box"> <p class="heading">Participant Name</p> <p class="title is-6">{parent.selectedParticipant.first_name} {parent.selectedParticipant.last_name}</p> </div> </div> <div class="column is-4-desktop is-12-mobile"> <div class="box"> <p class="heading">Kit Used</p> <p class="title is-6">{parent.selectedParticipant.progress.device}</p> </div> </div> <div class="column is-4-desktop is-12-mobile"> <div class="box"> <p class="heading">Current Progress</p> <p class="title is-6">{getStepProgressLabel()}</p> </div> </div> <div class="column is-12"> <div class="field"> <label class="label">Activity Completion</label> <progress class="progress is-info" riot-value="{getCurrentStepNumber()}" max="{getTotalSteps()}">{getStepProgressLabel()}</progress> <p class="is-size-7 has-text-grey">{getStepProgressLabel()}</p> </div> </div> </div> </div> </div> </div> </div> <div class="column is-12"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <header class="card-header"> <p class="card-header-title"> <span class="icon is-small" style="margin-right: 0.5rem;"> <i class="fas fa-question-circle"></i> </span> Knowledge Check Questions and Answers </p> </header> <div class="card-content"> <div class="content"> <div class="container is-fluid has-text-centered" show="{loading_participant_responses}" style="margin-top: 5px;"> <span class="button is-outlined is-rounded is-large is-danger is-loading">Loading</span> </div> <article class="message" each="{s,i in parent.parent.selectedActivity.lesson.steps}" if="{s.type===\'quiz\' && !loading_participant_responses}"> <div class="message-header"> <p>Step {i + 1}: {s.title}</p> <span class="tag is-light">{getAnsweredCountForStep(i)} / {getQuestionsForStep(i).length} answered</span> </div> <div class="message-body"> <div class="notification is-light" if="{getQuestionsForStep(i).length === 0}"> No questions are configured for this quiz step yet. </div> <div class="box" if="{getQuestionsForStep(i).length > 0}"> <div class="table-container"> <table class="table is-fullwidth is-striped is-hoverable"> <thead> <tr> <th>Question</th> <th>Answer</th> </tr> </thead> <tbody> <tr each="{q,qIndex in getQuestionsForStep(i)}"> <td>{getQuestionText(q, qIndex)}</td> <td> <span if="{getAnswerForQuestion(i, q)}">{getAnswerForQuestion(i, q)}</span> <span class="has-text-grey" if="{!getAnswerForQuestion(i, q)}">No response yet</span> </td> </tr> </tbody> </table> </div> </div> </div> </article> </div> </div> </div> </div> <div class="column is-12"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <header class="card-header"> <p class="card-header-title"> <span class="icon is-small" style="margin-right: 0.5rem;"> <i class="fas fa-chart-line"></i> </span> Measurements by Activity Step </p> </header> <div class="card-content"> <div class="content"> <div class="container is-fluid has-text-centered" show="{loading_participant_telemetry}" style="margin-top: 5px;"> <span class="button is-outlined is-rounded is-large is-danger is-loading">Loading</span> </div> <article class="message" each="{s,i in parent.parent.selectedActivity.lesson.steps}" if="{s.type===\'task\' && !loading_participant_telemetry}"> <div class="message-header"> <p>Step {i + 1}: {s.title}</p> <span class="tag is-light">{getMeasurementCountForStep(i)} measurements</span> </div> <div class="message-body"> <div class="notification is-light" if="{getTelemetryForStep(i).length === 0}"> No measurements captured for this step yet. </div> <div class="box" if="{getTelemetryForStep(i).length > 0}"> <div class="table-container"> <table class="table is-fullwidth is-striped is-hoverable"> <thead> <tr> <th>Timestamp</th> <th>Message</th> <th>Value</th> <th>Unit</th> </tr> </thead> <tbody> <tr each="{t in getTelemetryForStep(i)}"> <td>{epochToHumanDate(t._ts)}</td> <td> <span each="{m in t.data}">{m.msg?m.msg:m.type}<br></span> </td> <td> <span each="{m in t.data}">{prettyValue(m.value)}<br></span> </td> <td> <span each="{m in t.data}">{m.unit}<br></span> </td> </tr> </tbody> </table> </div> </div> </div> </article> </div> </div> </div> </div> </div>', '', '', function(opts) {
        var self = this;
        self.loading_participant_responses = false;
        self.loading_participant_telemetry = false;
        self.responses = [];
        self.telemetry = [];
        self.questions = [];
        self.lastSelectionRequestKey = undefined;
        self.currentlyLoadingRequestKey = undefined;
        self.lastQuestionLoadKey = undefined;

        function getLessonIdFromContext() {
            if (self.parent && self.parent.selectedActivity && self.parent.selectedActivity.lesson && self.parent.selectedActivity.lesson.id) {
                return self.parent.selectedActivity.lesson.id;
            }
            if (self.parent && self.parent.detailedActivity && self.parent.detailedActivity.lesson && self.parent.detailedActivity.lesson.id) {
                return self.parent.detailedActivity.lesson.id;
            }
            return undefined;
        }

        function maybeLoadQuestionsForLesson() {
            var lessonId = getLessonIdFromContext();
            if (!lessonId) {
                return;
            }

            var questionLoadKey = String(lessonId);
            if (self.lastQuestionLoadKey === questionLoadKey) {
                return;
            }

            self.lastQuestionLoadKey = questionLoadKey;
            getQuestions(lessonId);
        }

        function maybeLoadSelectedParticipantData() {
            var selectedParticipant = self.parent ? self.parent.selectedParticipant : undefined;
            var selectedActivity = self.parent ? self.parent.selectedActivity : undefined;
            if (!selectedParticipant || !selectedActivity || !selectedActivity.activity_ref) {
                return;
            }

            var requestKey = selectedActivity.activity_ref + '::' + selectedParticipant.user_id + '::' + selectedParticipant.progress.device;
            if (self.lastSelectionRequestKey === requestKey || self.currentlyLoadingRequestKey === requestKey) {
                return;
            }

            maybeLoadQuestionsForLesson();
            self.currentlyLoadingRequestKey = requestKey;
            getAnswers(selectedActivity.activity_ref, selectedParticipant.user_id);
            getActivityTelemetry(selectedParticipant.progress.device, selectedActivity.activity_ref);
            self.lastSelectionRequestKey = requestKey;
            self.currentlyLoadingRequestKey = undefined;
        }

        self.on('mount', function() {
            maybeLoadSelectedParticipantData();
        });

        self.on('updated', function() {
            maybeLoadSelectedParticipantData();
        });

        self.on('unmount', function() {
            self.lastSelectionRequestKey = undefined;
            self.currentlyLoadingRequestKey = undefined;
            self.lastQuestionLoadKey = undefined;
        });

        this.prettyValue = function(v) {
            if (!isNaN(v)) {

                return v.toFixed(2);
            }
            return v;
        }.bind(this)

        this.epochToHumanDate = function(epoch) {
            if (!epoch) return '';
            var d = new Date(0);
            d.setUTCSeconds(epoch);
            return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
        }.bind(this)

        this.getFirstQuizStepIndex = function() {
            if (!self.parent || !self.parent.selectedActivity || !self.parent.selectedActivity.lesson || !self.parent.selectedActivity.lesson.steps) {
                return -1;
            }
            for (var i = 0; i < self.parent.selectedActivity.lesson.steps.length; i++) {
                if (self.parent.selectedActivity.lesson.steps[i].type === 'quiz') {
                    return i;
                }
            }
            return -1;
        }.bind(this)

        this.getQuestionId = function(questionObj) {
            if (!questionObj) {
                return undefined;
            }
            return questionObj.id || questionObj.question_id || questionObj.questionId || questionObj._id;
        }.bind(this)

        this.getQuestionStepIndex = function(questionObj) {
            if (!questionObj) {
                return undefined;
            }

            var candidate = questionObj.activity_step;
            if (candidate === undefined || candidate === null) candidate = questionObj.step;
            if (candidate === undefined || candidate === null) candidate = questionObj.step_index;
            if (candidate === undefined || candidate === null) candidate = questionObj.lesson_step;
            if (candidate === undefined || candidate === null) return undefined;

            var parsed = parseInt(candidate, 10);
            return isNaN(parsed) ? undefined : parsed;
        }.bind(this)

        this.getQuestionsForStep = function(stepIndex) {
            if (!self.questions || self.questions.length === 0) {
                return [];
            }

            var hasStepMetadata = false;
            for (var i = 0; i < self.questions.length; i++) {
                if (this.getQuestionStepIndex(self.questions[i]) !== undefined) {
                    hasStepMetadata = true;
                    break;
                }
            }

            if (!hasStepMetadata) {
                return stepIndex === this.getFirstQuizStepIndex() ? self.questions : [];
            }

            var filtered = [];
            for (var j = 0; j < self.questions.length; j++) {
                if (this.getQuestionStepIndex(self.questions[j]) === stepIndex) {
                    filtered.push(self.questions[j]);
                }
            }
            return filtered;
        }.bind(this)

        this.getQuestionText = function(questionObj, questionIndex) {
            if (!questionObj) {
                return 'Question ' + (questionIndex + 1);
            }
            return questionObj.question || questionObj.prompt || questionObj.text || ('Question ' + (questionIndex + 1));
        }.bind(this)

        this.getAnswerForQuestion = function(stepIndex, questionObj) {
            if (!self.responses || self.responses.length === 0) {
                return '';
            }

            var qid = this.getQuestionId(questionObj);
            if (qid === undefined || qid === null) {
                return '';
            }

            var normalizedQid = String(qid);
            for (var i = 0; i < self.responses.length; i++) {
                var responseQid = self.responses[i].question_id !== undefined ? String(self.responses[i].question_id) : undefined;
                if (responseQid && responseQid === normalizedQid) {
                    return self.responses[i].answer || '';
                }
            }

            return '';
        }.bind(this)

        this.getAnsweredCountForStep = function(stepIndex) {
            var questions = this.getQuestionsForStep(stepIndex);
            var count = 0;

            for (var i = 0; i < questions.length; i++) {
                if (this.getAnswerForQuestion(stepIndex, questions[i])) {
                    count += 1;
                }
            }

            return count;
        }.bind(this)

        this.getTelemetryForStep = function(stepIndex) {
            if (!self.telemetry || self.telemetry.length === 0) {
                return [];
            }
            return self.telemetry.filter(function(t) {
                return t.activity_step == stepIndex;
            });
        }.bind(this)

        this.getMeasurementCountForStep = function(stepIndex) {
            return this.getTelemetryForStep(stepIndex).length;
        }.bind(this)

        this.getTotalSteps = function() {
            var steps = undefined;

            if (self.parent && self.parent.selectedActivity && self.parent.selectedActivity.lesson && self.parent.selectedActivity.lesson.steps) {
                steps = self.parent.selectedActivity.lesson.steps;
            } else if (self.parent && self.parent.detailedActivity && self.parent.detailedActivity.lesson && self.parent.detailedActivity.lesson.steps) {
                steps = self.parent.detailedActivity.lesson.steps;
            } else if (self.parent && self.parent.parent && self.parent.parent.selectedActivity && self.parent.parent.selectedActivity.lesson && self.parent.parent.selectedActivity.lesson.steps) {
                steps = self.parent.parent.selectedActivity.lesson.steps;
            }

            return steps ? steps.length : 0;
        }.bind(this)

        this.getCurrentStepNumber = function() {
            var total = this.getTotalSteps();
            var step = self.parent && self.parent.selectedParticipant && self.parent.selectedParticipant.progress ? self.parent.selectedParticipant.progress.step : 0;
            var current = parseInt(step, 10);
            if (isNaN(current)) current = 0;
            if (current < 0) current = 0;
            if (total <= 0) return 0;
            if (current > total) current = total;
            return current;
        }.bind(this)

        this.getStepProgressLabel = function() {
            return 'Step ' + this.getCurrentStepNumber() + ' of ' + this.getTotalSteps();
        }.bind(this)

        function getQuestions(lesson_id) {
            fetchQuestions(lesson_id).then(function(res) {
                self.update({
                    questions: res && res['data'] ? (res['data']['questions'] || []) : [],
                });
            }).catch(function(error) {
                console.error('GET Questions Error:' + error);
                self.update({
                    questions: [],
                });
            }.bind(this));
        }

        function getAnswers(act_ref, user_id) {
            self.loading_participant_responses = true;
            fetchAnswers(act_ref, user_id).then(function(res) {
                self.loading_participant_responses = false;
                self.update({
                    responses: res['data']['answers'] || [],
                });
            }).catch(function(error) {
                console.error('GET Answers Error:' + error);
                self.loading_participant_responses = false;
                self.update({
                    responses: [],
                    responsesError: error
                });
            }.bind(this));
        }

        function getActivityTelemetry(device, act_ref) {
            self.loading_participant_telemetry = true;
            self.update();
            fetchActivityTelemetry(device, act_ref).then(function(res) {
                self.loading_participant_telemetry = false;
                self.update({
                    telemetry: res['data']['telemetry'],
                    telemetryError: undefined
                });
            }).catch(function(error) {
                console.error('GET Telemetry Error:' + error);
                self.loading_participant_telemetry = false;
                self.update({
                    telemetry: [],
                    telemetryError: error
                });
            }.bind(this));
        }
});
